import { useContext } from 'react';
import { CartContext } from '../../context/cart.context';
import { useNavigate } from 'react-router-dom';
import Button from '../button/button.component';
import CartItem from '../cart-item/cart-item.component';
import {CartDropdownContainer, CartItems, EmptyMessage} from './cart-dropdown.styles.jsx';
const CartDropdown = () =>{
  const {cartItems} =useContext(CartContext);
  const navigate = useNavigate();
  const checkOutHandler = () => {
    navigate ('/checkout')
  }

  return(
    <CartDropdownContainer>
        <CartItems> 
          {cartItems.length ? (
              cartItems.map((item) => <CartItem key={item.id} cartItem={item}/>)
            ) : (
              <EmptyMessage>Your cart is empty.</EmptyMessage>
            )}
        </CartItems>
        <Button onClick={checkOutHandler}>Go To Checkout</Button>
    </CartDropdownContainer>
  );
};

export default CartDropdown;